import { render, staticRenderFns } from "./ItemTemplateView.vue?vue&type=template&id=37fcaeb3&scoped=true&"
import script from "./ItemTemplateView.vue?vue&type=script&lang=ts&"
export * from "./ItemTemplateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcaeb3",
  null
  
)

export default component.exports